<template>
    <v-card flat tile>
      <v-toolbar color="primary" dark>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon @click="onCloseDialogHandler">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-3">
          <ApiForm 
            ref="serviceRealizationForm"
            :formElements="formElements"
            :endpoint="endpoint"
            :method="method"
            :cancel="cancel"
            :submit="submit"
            :formObject="selectedItem"
            :successFn="handleSuccess"
            :extractErrorsFn="extractErrorsFn"
            :submitOnEnter="false"
          >
          </ApiForm>
        </v-card-text>
  </v-card>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import VDateTextBox from '@/components/custom/VDateTextBox'
import httpClient from '@/api/httpClient'

export default {
  props: {
    dataObject: {},
    isUpdate: Boolean,
    title: String
  },
  data() {
    return {
      serviceObject: Object,
      showDate: false,
      selectedItem: {},
      endPoint: '/plannedServices',
      cancel: { text: '$cancel', color: 'secondary' },
      submit: { text: '$submit', color: 'primary' },
      formElements: [
        { key: 'name', rules: 'required', label: '$name', cols: 12 },
        {
          key: 'registrationPlate',
          label: '$vehicle',
          rules: 'required',
          cols: { sm: 12, lg: 6 },
          component: 'v-autocomplete',
          dataSource: {
            endpoint: '/vehicles',
            textProperty: 'name',
            valueProperty: 'registrationMark'
          }
        },
        {
          key: 'serviceType',
          rules: 'required',
          component: 'v-autocomplete',
          label: '$servicetype',
          cols: { sm: 12, lg: 6 },
          dataSource: { endpoint: '/serviceTypes' }
        },
        {
          key: 'currencyId',
          label: '$currency',
          rules: 'required',
          component: 'v-autocomplete',
          cols: { sm: 12, lg: 6 },
          dataSource: { endpoint: '/currencies' }
        },
        { key: 'cost', label: '$cost', rules: 'required', cols: { sm: 12, lg: 6 } },
        {
          key: 'realizedDate',
          label: '$realizedDate',
          rules: 'required',
          component: 'v-date-field',
          props: {
            onlyDate: true
          }
        },
        {
          key: 'workDone',
          label: '$workDone',
          component: 'v-textarea',
          cols: { sm: 12, lg: 6 }
        },
        {
          key: 'partsReplaced',
          label: '$partsReplaced',
          component: 'v-textarea',
          cols: { sm: 12, lg: 6 }
        },
        {
          key: 'additionalComments',
          label: '$additionalComments',
          component: 'v-textarea',
          cols: { sm: 12, lg: 6 }
        },
        {
          key: 'description',
          label: '$description',
          component: 'v-textarea',
          cols: { sm: 12, lg: 6 }
        },
        {
          key: "serviceScheduleId",
          component: "v-text-field",
          hidden: true,
          sendOnHidden: true
        }
      ]
    }
  },
  components: {
    SubmitGroup: () => import('@/components/SubmitGroup'),
    ValidationProvider,
    ValidationObserver,
    VDateTextBox
  },
  computed: {
    bPoint() {
      return this.$vuetify.breakpoint
    },
    endpoint() {
      if (this.isUpdate) {
        return this.endPoint + '/' + this.dataObject.id
      } else {
        return this.endPoint
      }
    },
    method() {
      if (this.isUpdate) {
        return 'put'
      } else {
        return 'post'
      }
    }
  },
  methods: {
    handleSuccess: function() {
      this.selectedItem = {}
      let message = ''
      if (this.isUpdate){
        message = this.getTranslation('successUpdate')
      }
      else {
        message = this.getTranslation('successInsert')
      }  
      this.$emit('snackbarMessage', message)
      this.$emit('close')
    },
    shouldBeDisabled() {
      if (this.dataObject.id != null && this.dataObject.isRealized == false) {
        return true
      }
      return false
    },
    getTranslation(toTranslate) {
      return translate(toTranslate, 'pages.serviceRealization')
    },
    onCloseDialogHandler() {
      if (!this.$refs.serviceRealizationForm) {
        return
      }

      this.$refs.serviceRealizationForm.resetForm()
      this.selectedItem = {}
      this.$emit('close')
    },
    extractErrorsFn(data) {
      return data.errors.map(el => {
        return {
          propertyName: el.PropertyName,
          error: el.Error
        }
      })
    },
    async handleServiceScheduleId() {
      await httpClient
        .get('serviceSchedules/' + this.dataObject.id)
        .then(response => {
          this.serviceObject = response.data
        })
      let object = {}
      object.registrationPlate = this.serviceObject.vehicleLabel
      object.serviceType = this.serviceObject.serviceType
      object.name = this.serviceObject.name
      object.description = this.serviceObject.description
      object.plannedDate = this.serviceObject.plannedDate
      object.serviceScheduleId = this.dataObject.id
      this.selectedItem = object
    },
    async handleServiceRealizationId() {
      await httpClient
        .get('plannedServices/' + this.dataObject.id)
        .then(response => {
          let object = {}
          object.registrationPlate = response.data.registrationPlate
          object.serviceType = response.data.serviceType
          object.name = response.data.name
          object.description = response.data.description
          object.plannedDate = response.data.plannedDate
          object.realizedDate = response.data.realizedDate
          object.serviceScheduleId = response.data.id
          object.cost = response.data.cost
          object.currencyId = response.data.currencyId
          object.workDone = response.data.workDone
          object.partsReplaced = response.data.partsReplaced
          object.additionalComments = response.data.additionalComments
          object.serviceScheduleId = response.data.serviceScheduleId
          object.id = response.data.id
          this.selectedItem = object
        })
    },
    handleServiceById() {
      if (this.dataObject.id != null && this.dataObject.isRealized == false) {
        this.handleServiceScheduleId()
      }
      if (this.dataObject.id != null && this.dataObject.isRealized == true) {
        this.handleServiceRealizationId()
      }
      if (this.dataObject.id == null && this.dataObject.isRealized == false) {
        this.selectedItem = {}
      }
      if (Object.keys(this.selectedItem).length === 0) {
        this.$refs.serviceRealizationForm.resetForm()
      }
    }
  },
  mounted() {
    this.handleServiceById()
  },
  watch: {
    dataObject: {
      handler() {
        this.handleServiceById()
      }
    }
  }
}
</script>
